// extracted by mini-css-extract-plugin
export default {"footer":"styles_footer__0SzoX","footerWrapper":"styles_footerWrapper__MlMR6","links":"styles_links__14D4I"};